import React, { useContext, forwardRef } from 'react';
import { Table as MuiTable, TableContainer, TableHead } from '@mui/material';
import TableContext from "./context";
import THeader from "./THeader";
import TBody from "./TBody";
var NTable = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(TableContext),
    height = _useContext.height,
    showHeader = _useContext.showHeader;
  return /*#__PURE__*/React.createElement(TableContainer, {
    ref: ref,
    sx: {
      height: height
    }
  }, /*#__PURE__*/React.createElement(MuiTable, {
    stickyHeader: true,
    sx: {
      tableLayout: 'fixed'
    }
  }, showHeader && /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(THeader, null)), /*#__PURE__*/React.createElement(TBody, null)));
});
export default NTable;